import React, { useCallback, useEffect, useState } from "react";
import Header from "../header";
import SearchField from "../../searchField";
import Button from "../../Button";
import { FiPlus } from "react-icons/fi";
import TabManager from "../../tabManager";
import PaymnetTable from "../tables/Settings-Table/paymentTable";
import StoreTable from "../tables/Settings-Table/storeTable";
import Modal from "../../modal";
import Input from "../../Input";
import PasswordInput from "../../passwordInput";
import MultiSelectDropdown from "../../multiSelectDropdown";
import {
  validatePaymentForm,
  validateselectedIdForm,
  validateUserForm,
} from "../../../validation/SettingsValidation";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AddStore,
  DeleteStore,
  GetUsersData,
  UpdateStore,
} from "../../../redux/Auth/actions";
import useInfiniteScroll from "../../Hooks/useInfiniteScroll";
import {
  addPayment,
  DeletePayment,
  getPayment,
  UpdatePayment,
} from "../../../redux/payment/action";
import SelectInput from "../../selectInput";

const Settings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("Stores");
  const [searchValue, setSearchValue] = useState(""); // State for search input
  const [isOpen, setIsOpen] = useState(false);
  const [isStoreOpen, setIsStoreOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    id: "",
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });

  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [hasMoreStore, setHasMoreStore] = useState(true);
  const [selectedId, setSelectedId] = useState([]);
  const [paymentFormData, setPaymentFormData] = useState({
    paymentMethod: "",
    Maximum: Number,
    balance: Number,
    stores: [""],
    type: "",
  });
  const [filterPayment, setFilterPayment] = useState({
    page: 1,
    limit: 10,
  });
  const [storeLimit, setStoreLimit] = useState(20);
  const [userLoading, setUserLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [ispaymentSubmit, setIsPaymentSubmit] = useState(false);
  const [paymentErrors, setPaymentErrors] = useState({});
  const [paymentSelectedIdErrors, setPaymentSelectedIdErrors] = useState();
  const [isPaymentDeleteOpen, setIsPaymentDeleteOpen] = useState(false);
  const [currentPaymentRow, setCurrentPaymentRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isUserEditMode, setIsUserEditMode] = useState(false);

  const usersData = useSelector((state) => state?.Auth?.usersData?.data);
  const getPaymentData = useSelector(
    (state) => state?.Payment?.getPayment?.data
  );

  const tabItems = [
    { title: "Stores", key: "Stores" },
    { title: "Payment Method", key: "PaymentMethod" },
  ];

  // Ensure usersData is defined and not empty
  const options = usersData
    ? usersData.map((e) => ({
        label: e?.store?.name ? e?.store?.name : e?.user?.name,
        value: e?._id,
      }))
    : [];

  const openModal = () => {
    setIsUserEditMode(false);
    setIsOpen(true);
  };
  const openStoreModal = (rowIndex) => {
    setCurrentRow(rowIndex);
    setIsStoreOpen(true);
  };
  const openPaymentModal = () => {
    resetPaymentForm();
    setIsEditMode(false);
    setIsPaymentOpen(true);
  };
  const openPaymentDeleteModal = (rowIndex) => {
    setCurrentPaymentRow(rowIndex);
    setIsPaymentDeleteOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setFormData({ name: "", id: "", email: "", password: "" });
    setErrors({});
    setIsSubmit(false);
  };
  const closeStoreModal = () => setIsStoreOpen(false);
  const closePaymentDeleteModal = () => setIsPaymentDeleteOpen(false);
  const closePaymentModal = () => setIsPaymentOpen(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    // Re-validate the form on input change
    if (isSubmit) {
      const validationErrors = validateUserForm({
        ...paymentFormData,
        [name]: value,
      });
      setPaymentErrors(validationErrors);
    }
  };

  const openUserEditModal = (row) => {
    setFormData({
      name: row?.store?.name,
      id: row?.id,
      email: row?.email,
      password: row?.password,
    });
    setIsUserEditMode(true);
    setCurrentRow(row);
    setIsOpen(true);
  };

  const handleAddUser = async () => {
    setIsSubmit(true);
    const validationErrors = validateUserForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setUserLoading(true);
      // Handle form submission (e.g., API call)
      let obj = {
        name: formData?.name,
        email: formData?.email,
        password: formData?.password,
        id: formData?.id,
        role: "Store",
      };

      if (isUserEditMode) {
        await dispatch(UpdateStore({ id: currentRow?._id, data: obj })).then(
          (res) => {
            if (res?.status === 200) {
              dispatch(
                GetUsersData({
                  page: filter?.page,
                  limit: filter?.limit,
                  search: searchValue,
                })
              );
              setUserLoading(false);
            }
            if (res?.data?.status === 401) {
              setUserLoading(false);
              navigate("/");
            }
          }
        );
      } else {
        await dispatch(AddStore(obj)).then((res) => {
          if (res?.status === 200) {
            dispatch(
              GetUsersData({
                page: filter?.page,
                limit: filter?.limit,
                search: searchValue,
              })
            );
            setUserLoading(false);
          }
          if (res?.data?.status === 401) {
            setUserLoading(false);
            navigate("/");
          }
        });
      }
      setUserLoading(false);
      closeModal();
    }
  };

  const handleDeleteStore = () => {
    setUserLoading(true);
    dispatch(DeleteStore(currentRow?._id)).then((res) => {
      if (res?.status === 200) {
        dispatch(
          GetUsersData({
            page: filter?.page,
            limit: filter?.limit,
            search: searchValue,
          })
        );
        setUserLoading(false);
      }
      if (res?.data?.status === 401) {
        navigate("/");
        setUserLoading(false);
      }
      setUserLoading(false);
      closeStoreModal();
    });
  };

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      if (activeTab === "Stores") {
        setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
      } else if (activeTab === "PaymentMethod") {
        setFilterPayment((prev) => ({ ...prev, limit: prev.limit + 10 }));
      }
    }
  }, [hasMoreData, activeTab, filter, filterPayment]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Re-validate the form on input change
      if (ispaymentSubmit) {
        const validationErrors = validatePaymentForm(updatedData);
        setPaymentErrors(validationErrors);
      }

      return updatedData;
    });
  };

  const typeOption = [
    {
      lable: "Cash",
      value: "cash",
    },
    {
      lable: "Bank",
      value: "bank",
    },
    {
      lable: "Credit",
      value: "credit",
    },
  ];

  const openEditModal = (row) => {
    const storeIds = row?.stores?.map((store) => store._id);
    setPaymentFormData({
      paymentMethod: row?.paymentmethod,
      balance: row?.Balance,
      Maximum: row?.Maximum,
      type: row?.type,
      stores: storeIds,
    });
    setSelectedId(storeIds);
    setIsEditMode(true);
    setIsPaymentOpen(true);
    setCurrentRow(row);
  };

  const resetPaymentForm = () => {
    setSelectedId([]);
    setPaymentFormData({
      paymentMethod: "",
      balance: Number,
      Maximum: Number,
      type: "",
      stores: [""],
    });
  };

  const handleAddPaymentMethod = async () => {
    setIsPaymentSubmit(true);
    const validationErrors = validatePaymentForm(paymentFormData);
    const selectedIdErrors = validateselectedIdForm(selectedId);

    setPaymentErrors(validationErrors);
    setPaymentSelectedIdErrors(selectedIdErrors);

    if (Object.keys(validationErrors).length === 0 && !selectedIdErrors) {
      setPaymentLoading(true);
      let obj = {
        paymentmethod: paymentFormData?.paymentMethod,
        Balance: paymentFormData?.balance,
        Maximum: paymentFormData?.Maximum,
        type: paymentFormData?.type,
        stores: selectedId,
      };

      if (isEditMode) {
        await dispatch(UpdatePayment({ id: currentRow?._id, data: obj })).then(
          (res) => {
            if (res?.status === 200) {
              dispatch(
                getPayment({
                  page: filterPayment?.page,
                  limit: filterPayment?.limit,
                  search: searchValue,
                })
              );
              setPaymentLoading(false);
            }
            if (res?.data?.status === 401) {
              setPaymentLoading(false);
              navigate("/");
            }
          }
        );
        setPaymentLoading(false);
      } else {
        await dispatch(addPayment(obj)).then((res) => {
          if (res?.status === 200) {
            dispatch(
              getPayment({
                page: filterPayment?.page,
                limit: filterPayment?.limit,
                search: searchValue,
              })
            );
            setPaymentLoading(false);
          }
          if (res?.data?.status === 401) {
            setPaymentLoading(false);
            navigate("/");
          }
        });
        setPaymentLoading(false);
      }
      // Add your submission logic here
      setSelectedId([]);
      resetPaymentForm();
      setPaymentLoading(false);
      closePaymentModal();
    }
  };

  const handleDeletePayment = () => {
    setPaymentLoading(true);
    dispatch(DeletePayment(currentPaymentRow?._id)).then((res) => {
      if (res?.status === 200) {
        dispatch(
          getPayment({
            page: filterPayment?.page,
            limit: filterPayment?.limit,
            search: searchValue,
          })
        );
        setPaymentLoading(false);
      }
      if (res?.data?.status === 401) {
        setPaymentLoading(false);
        navigate("/");
      }
      setPaymentLoading(false);
      closePaymentDeleteModal();
    });
  };

  const fetchMoreStore = () => {
    const newLimit = storeLimit + 10;
    setStoreLimit(newLimit);
  };

  useEffect(() => {
    if (activeTab === "Stores") {
      dispatch(
        GetUsersData({
          page: filter?.page,
          limit: filter?.limit,
          search: searchValue,
        })
      ).then((res) => {
        if (res?.data?.status === 401) {
          navigate("/");
        }

        if (res?.data?.length === 0) {
          setHasMoreData(false);
        }

        if (res?.data?.status === 401) {
          navigate("/");
        }
      });
    }
  }, [dispatch, navigate, filter, searchValue, activeTab]);

  useEffect(() => {
    if (activeTab === "PaymentMethod") {
      dispatch(
        getPayment({
          page: filterPayment?.page,
          limit: filterPayment?.limit,
          search: searchValue,
        })
      ).then((res) => {
        if (res?.data?.status === 401) {
          navigate("/");
        }

        if (res?.data?.length === 0) {
          setHasMoreData(false);
        }
      });
    }
  }, [dispatch, navigate, filterPayment, searchValue, activeTab]);

  useEffect(() => {
    if (activeTab === "PaymentMethod") {
      dispatch(
        GetUsersData({
          page: filterPayment?.page,
          limit: storeLimit,
          search: "",
        })
      ).then((res) => {
        if (res?.data?.length === 0) {
          setHasMoreStore(false); // No more data to fetch
        }
        if (res?.data?.status === 401) {
          navigate("/");
        }
      });
    }
  }, [dispatch, navigate, filterPayment, activeTab, storeLimit, hasMoreStore]);

  useEffect(() => {
    // Reset searchValue when activeTab changes
    setSearchValue("");
    setHasMoreData(true);
  }, [activeTab]);

  useEffect(() => {
    if (ispaymentSubmit) {
      const selectedIdErrors = validateselectedIdForm(selectedId);
      setPaymentSelectedIdErrors(selectedIdErrors);
    }
  }, [ispaymentSubmit, selectedId]);

  return (
    <div className="w-full px-8 py-2 flex flex-col gap-[30px]">
      <Header title={"Settings"} />

      <div className="flex justify-between items-center max-xl:flex-col max-xl:gap-3">
        <div className="max-xl:w-full">
          <TabManager
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabItems={tabItems}
          />
        </div>

        <div className="flex items-center gap-5 max-xl:w-full max-xl:flex max-xl:items-center max-xl:justify-end">
          <SearchField
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
          {activeTab === "Stores" && (
            <>
              <Button
                className={"bg-green hover:bg-darkgreen text-white"}
                icon={<FiPlus />}
                children={"Add New User"}
                onClick={openModal}
              />
              <Modal
                loading={userLoading}
                modalWidth={"w-1/2"}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                openModal={openModal}
                closeModal={closeModal}
                imgSrc="/images/addVendors.svg"
                title={isUserEditMode ? "Update User" : "Add New User"}
                btn1="Cancel"
                btn2={isUserEditMode ? "Save" : "Add User"}
                btnClass={"justify-end"}
                handleBtn2={handleAddUser}
                modalContent={
                  <div className="grid grid-cols-2 gap-x-5 gap-y-5 text-base font-normal">
                    <div>
                      <Input
                        lableName={"Name"}
                        inputType={"text"}
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        error={errors.name}
                      />
                      {errors.name && (
                        <div className="text-red-500 text-sm">
                          {errors.name}
                        </div>
                      )}
                    </div>
                    <div>
                      <Input
                        lableName={"Id"}
                        inputType={"number"}
                        name="id"
                        value={formData.id}
                        onChange={handleInputChange}
                        error={errors.id}
                      />
                      {errors.id && (
                        <div className="text-red-500 text-sm">{errors.id}</div>
                      )}
                    </div>
                    <div>
                      <Input
                        lableName={"Email"}
                        inputType={"email"}
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        error={errors.email}
                      />
                      {errors.email && (
                        <div className="text-red-500 text-sm">
                          {errors.email}
                        </div>
                      )}
                    </div>
                    <div>
                      <PasswordInput
                        lableName={"Password"}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        error={errors.password}
                      />
                      {errors.password && (
                        <div className="text-red-500 text-sm">
                          {errors.password}
                        </div>
                      )}
                    </div>
                  </div>
                }
              />
            </>
          )}
          {activeTab === "PaymentMethod" && (
            <>
              <Button
                onClick={openPaymentModal}
                className={"bg-green hover:bg-darkgreen text-white"}
                icon={<FiPlus />}
                children={"Add Payment Method"}
              />
              <Modal
                loading={paymentLoading}
                modalWidth={"w-1/2"}
                isOpen={isPaymentOpen}
                setIsOpen={setIsPaymentOpen}
                openModal={openPaymentModal}
                closeModal={closePaymentModal}
                imgSrc="/images/addPaymentIcon.svg"
                title={
                  isEditMode ? "Update Payment Method" : "Add Payment Method"
                }
                btn1="Cancel"
                btn2={isEditMode ? "Save" : "Add Method"}
                btnClass={"justify-end"}
                handleBtn2={handleAddPaymentMethod}
                modalContent={
                  <div className="grid grid-cols-2 gap-x-5 gap-y-5 text-base font-normal">
                    <div>
                      <Input
                        lableName={"Payment Method"}
                        inputType={"text"}
                        name="paymentMethod"
                        value={paymentFormData.paymentMethod}
                        onChange={handlePaymentInputChange}
                        error={paymentErrors.paymentMethod}
                      />
                      {paymentErrors.paymentMethod && (
                        <div className="text-red-500 text-sm">
                          {paymentErrors.paymentMethod}
                        </div>
                      )}
                    </div>
                    <div>
                      <Input
                        lableName={"Balance"}
                        inputType={"number"}
                        currency={true}
                        name="balance"
                        value={paymentFormData.balance}
                        onChange={handlePaymentInputChange}
                        error={paymentErrors.balance}
                      />
                      {paymentErrors.balance && (
                        <div className="text-red-500 text-sm">
                          {paymentErrors.balance}
                        </div>
                      )}
                    </div>
                    <div>
                      <Input
                        lableName={"Maximum"}
                        inputType={"number"}
                        currency={true}
                        name="Maximum"
                        value={paymentFormData.Maximum}
                        onChange={handlePaymentInputChange}
                        error={paymentErrors.Maximum}
                      />
                      {paymentErrors.Maximum && (
                        <div className="text-red-500 text-sm">
                          {paymentErrors.Maximum}
                        </div>
                      )}
                    </div>
                    <div>
                      <SelectInput
                        lableName={"Type"}
                        option={typeOption}
                        onChange={handlePaymentInputChange}
                        value={paymentFormData?.type}
                        name={"type"}
                        error={paymentErrors.type}
                        // fetchMoreOptions={fetchMoreOptionsLoanType}
                      />
                      {paymentErrors.type && (
                        <div className="text-red-500 text-sm">
                          {paymentErrors.type}
                        </div>
                      )}
                    </div>
                    <div className="col-span-2">
                      <MultiSelectDropdown
                        options={options}
                        lableName={"Store"}
                        className={"w-full col-span-2"}
                        setSelectedId={setSelectedId}
                        selectedValues={selectedId}
                        fetchMoreData={fetchMoreStore} // Pass the function
                        hasMoreData={hasMoreStore}
                      />
                      {paymentSelectedIdErrors && (
                        <div className="text-red-500 text-sm">
                          {paymentSelectedIdErrors}
                        </div>
                      )}
                    </div>
                  </div>
                }
              />
            </>
          )}
        </div>
      </div>

      <div>
        {activeTab === "Stores" && (
          <StoreTable
            loading={userLoading}
            usersData={usersData}
            setIsStoreOpen={setIsStoreOpen}
            isStoreOpen={isStoreOpen}
            openStoreModal={openStoreModal}
            closeStoreModal={closeStoreModal}
            handleDeleteStore={handleDeleteStore}
            lastElementRef={lastElementRef}
            openUserEditModal={openUserEditModal}
          />
        )}
        {activeTab === "PaymentMethod" && (
          <PaymnetTable
            loading={paymentLoading}
            getPaymentData={getPaymentData}
            openPaymentDeleteModal={openPaymentDeleteModal}
            closePaymentDeleteModal={closePaymentDeleteModal}
            setIsPaymentDeleteOpen={setIsPaymentDeleteOpen}
            isPaymentDeleteOpen={isPaymentDeleteOpen}
            handleDeletePayment={handleDeletePayment}
            lastElementRef={lastElementRef}
            openEditModal={openEditModal}
          />
        )}
      </div>
    </div>
  );
};

export default Settings;
